/**
 * Authenticated API utility
 * Wraps fetch calls with Clerk authentication token
 */

/**
 * Make an authenticated API request
 * @param {string} url - The API endpoint
 * @param {object} options - Fetch options
 * @param {string} token - Clerk auth token from useAuth().getToken()
 * @returns {Promise<Response>}
 */
export const authFetch = async (url, options = {}, token) => {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return fetch(url, {
    ...options,
    headers,
  });
};

/**
 * Make an authenticated POST request
 * @param {string} url - The API endpoint
 * @param {object} data - Request body data
 * @param {string} token - Clerk auth token
 * @returns {Promise<any>}
 */
export const authPost = async (url, data, token) => {
  const response = await authFetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
  }, token);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error: ${response.status}`);
  }

  return response.json();
};
